var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalDotsWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.832 6C10.832 5.60218 10.9901 5.22064 11.2714 4.93934C11.5527 4.65804 11.9342 4.5 12.332 4.5C12.7299 4.5 13.1114 4.65804 13.3927 4.93934C13.674 5.22064 13.832 5.60218 13.832 6C13.832 6.39782 13.674 6.77936 13.3927 7.06066C13.1114 7.34196 12.7299 7.5 12.332 7.5C11.9342 7.5 11.5527 7.34196 11.2714 7.06066C10.9901 6.77936 10.832 6.39782 10.832 6ZM10.832 12C10.832 11.6022 10.9901 11.2206 11.2714 10.9393C11.5527 10.658 11.9342 10.5 12.332 10.5C12.7299 10.5 13.1114 10.658 13.3927 10.9393C13.674 11.2206 13.832 11.6022 13.832 12C13.832 12.3978 13.674 12.7794 13.3927 13.0607C13.1114 13.342 12.7299 13.5 12.332 13.5C11.9342 13.5 11.5527 13.342 11.2714 13.0607C10.9901 12.7794 10.832 12.3978 10.832 12ZM10.832 18C10.832 17.6022 10.9901 17.2206 11.2714 16.9393C11.5527 16.658 11.9342 16.5 12.332 16.5C12.7299 16.5 13.1114 16.658 13.3927 16.9393C13.674 17.2206 13.832 17.6022 13.832 18C13.832 18.3978 13.674 18.7794 13.3927 19.0607C13.1114 19.342 12.7299 19.5 12.332 19.5C11.9342 19.5 11.5527 19.342 11.2714 19.0607C10.9901 18.7794 10.832 18.3978 10.832 18Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDotsWhite);
export default __webpack_public_path__ + "static/media/vertical-dots-white.2ed5c1ca36f81e95aebdbccc470e9df7.svg";
export { ForwardRef as ReactComponent };